<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512" @click="$emit('click')">
    <title>Arrow Back</title>
    <path
      fill="none"
      stroke="#333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="60"
      d="M244 400L100 256l144-144M120 256h292"
    />
  </svg>
</template>

<script>
export default {
  name: "Back",
};
</script>

<style scoped lang="scss">
.ionicon {
  width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/icons/Back.vue